import axios from "./Axios";
import { error, success } from "./ResponseHandler";

export const NSC_URL = process.env.REACT_APP_NSC_URL;

class NSCSSO {
    async getToken (tokenRequest){
        try {
            const response = await axios.post(`${NSC_URL}/api/oauth/token`, tokenRequest);

            return success({ data: response });
        } catch (e) {
            return error(e);
        }

    }

    async getProfile () {
        try {
            const response = await axios.get(`${NSC_URL}/api/users/me`);

            return success({ data: response });
        } catch (e) {
            return error(e);
        }
    }
}

export default new NSCSSO();
